import { ITotalRowsPage } from '../../../../../../../../../../../interfaces/response';
import { DashboardDefaults } from '../../../../../defaults';

export const isMoreThanLimit = (items: ITotalRowsPage<any>) => {
  return items.total_rows_count > DashboardDefaults.MAX_FETCHING_DATA_LIMIT;
};
